import { render, staticRenderFns } from "./RealtimeMonitor.vue?vue&type=template&id=8d6383a2&scoped=true"
import script from "./RealtimeMonitor.vue?vue&type=script&lang=js"
export * from "./RealtimeMonitor.vue?vue&type=script&lang=js"
import style0 from "./RealtimeMonitor.vue?vue&type=style&index=0&id=8d6383a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6383a2",
  null
  
)

export default component.exports